export type HexProps = {
    background: string;
    outTop: string;
    inTop: string;
    outBottom: string;
    inBottom: string;
};

export const Waves1: HexProps = {
    background: '#fee440',
    outTop: '#9b5de5',
    inTop: '#f15bb5',
    outBottom: '#00bbf9',
    inBottom: '#00f5d4',
};

export const Waves2: HexProps = {
    // Ultraviolet Garden (Deep violet with poisonous greens)
    background: '#240046',
    outTop: '#7b2cbf',
    inTop: '#ccff33',
    outBottom: '#9d4edd',
    inBottom: '#39ff14',
};

export const Waves3: HexProps = {
    // Synthwave Dusk (Deep navy-blue with electric magenta)
    background: '#140152',
    outTop: '#270082',
    inTop: '#7b2cbf',
    outBottom: '#3a0ca3',
    inBottom: '#00d1ff',
};


export const Waves4: HexProps = {
    // Radioactive Ocean (Deep Navy background with Acid Green and Teal)
    background: '#001d3d',
    outTop: '#003566',
    inTop: '#39ff14',
    outBottom: '#3c096c',
    inBottom: '#ff9100',
};

export const Waves5: HexProps = {
    // Toxic Jungle (Deep forest base with fluorescent purple and coral)
    background: '#002117',
    outTop: '#006442',
    inTop: '#bd00ff',
    outBottom: '#0b3d2e',
    inBottom: '#ff006e',
};

export const Waves6: HexProps = {
    // High-Voltage Sunset (Royal blue base with solar orange and vivid cyan)
    background: '#0028ff',
    outTop: '#001233',
    inTop: '#ff7b00',
    outBottom: '#3c096c',
    inBottom: '#00f5ff',
};

export const Waves7: HexProps = {
    // Candy Midnight (Dark violet base with peach punch and aqua blast)
    background: '#1d0e2c',
    outTop: '#9d4edd',
    inTop: '#ff8a5b',
    outBottom: '#054a91',
    inBottom: '#3efeff',
};